<template>
    <div class="dashboard_container" style="min-width: 1310px;">
        <div class="tfa-dashboard-section cn-dashboard-section">
            <div class="top-section row">
                <div class="dashboard-row stream-section col-12" style="max-width: 100%;">
                    <div>
                        <div class="card" style="min-height: 475px !important; min-width: 846px;">
                            <div class="card-body text-center mt-5">
                                <h4>Your transaction was not successful. You will be redirected on subscription page in few seconds.</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import '../../../assets/module/css/dashboard/tfaDashboard.min.css'

    export default {
      name: 'clearly-next-student-subscription-failure',

      mounted () {
        this.navigateToUserSubscriptionPage()
      },

      methods: {
        navigateToUserSubscriptionPage () {
          let userId = this.$route.query.u_id
          setTimeout(() => {
            return this.$router.push({name: 'clearlyNextStudentSubscription', params: {uuid: userId}})
          }, 5000)
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/app/user/components/ClearlyNextStudentSubscriptionFailure.vue